import { gql } from '@apollo/client';

export const GET_STYLING_SESSION_OUTCOMES = gql`
    query GetStylingSessionOutcomes($input: GetStylingSessionOutcomesInput!) {
        getStylingSessionOutcomes(input: $input) {
            id
            sessionTaffiId
            type
            created
            creator
            productTaffiId
            style {
                id
                created
                collection
                taffiId
                title
                description
                images
                items {
                    id
                    data {
                        id
                        collection
                        taffiId
                        price
                        currency
                        title
                        description
                        url
                        images
                    }
                }
                currency
                price
                status
            }
            styleGuide {
                id
                customerId
                stylistId
                creator
                created
                styleGuideUrl
            }
            item {
                id
                collection
                taffiId
                price
                currency
                available
                title
                description
                url
                images
                maxNumOfStyles
                maxNumOfItems
                creator
                created
                status
                inStock
            }
            stylingSession {
                id
                taffiId
                customer {
                    id
                    email
                    firstName
                    lastName
                    profileImageUrl
                }
                stylist {
                    id
                    email
                }
                startTime
                answers {
                    id
                    questionId
                    value
                }
            }
        }
    }
`;
